import React, { FC, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Paper, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { CustomSVG, InviteDialog } from 'components';
import { useClient, useCurrentUser, useFeatures } from 'hooks';
import { isAdminUser } from 'helpers';

interface IProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      cursor: 'pointer',
    },
    text: {
      marginTop: theme.spacing(2),
      fontStyle: 'italic',
    },
  });

const InviteModule: FC<IProps> = ({ classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const currentUser = useCurrentUser();
  const client = useClient();
  const { leaderboard } = useFeatures();

  const isAdmin = isAdminUser(currentUser);
  const noInvites = !client.allow_user_invites;

  if (isAdmin || noInvites) {
    return null;
  }

  function openInvite(event: MouseEvent<HTMLDivElement>) {
    setAnchorEl(event.currentTarget);
  }

  function closeInvite() {
    setAnchorEl(null);
  }

  return (
    <Grid item xs>
      <Paper className={classes.root} onClick={openInvite}>
        <Grid container alignItems="center" justify="space-between" wrap="nowrap">
          <Grid item>
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <CustomSVG name="peopleAdd" color="primary" />
              </Grid>
              <Grid item>
                <Typography variant="subtitle2">{t('invites:module')}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <AddCircleOutlineIcon color="primary" />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs>
            <Typography className={classes.text}>
              {leaderboard ? t('invites:moduleTextLeaderboard') : t('invites:moduleText')}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <InviteDialog open={!!anchorEl} onClose={closeInvite} />
    </Grid>
  );
};

export default withStyles(styles)(InviteModule);
